// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AplikacijeZaUpis_wrapper__3etP8 {
  margin-top: 64px;
  background-color: #e8fee8;
  border-radius: 8px;
  padding: 20px;
}
.AplikacijeZaUpis_header__BtZ1j {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.028px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencijaPolaznika/components/AplikacijeZaUpis/AplikacijeZaUpis.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B","sourcesContent":[".wrapper {\n  margin-top: 64px;\n  background-color: #e8fee8;\n  border-radius: 8px;\n  padding: 20px;\n}\n.header {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.028px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AplikacijeZaUpis_wrapper__3etP8`,
	"header": `AplikacijeZaUpis_header__BtZ1j`
};
export default ___CSS_LOADER_EXPORT___;
